module.exports = new __parcel__URL__("thaddeus.7b3e576a.webp").toString();